module.exports = __webpack_public_path__ + "assets/img/no_image.c4900e82.svg";